module.exports = __webpack_public_path__ + "img/szhx_titIcon2.561faa4c.png";